import { connect } from 'react-redux';

import SalesforceView from './SalesforceView.jsx';
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { authenticateAccount,changePrimaryConfiguration, fetchSalesforceIntegration, fetchTotalSalesforceIntegrations } from 'src/legacy/redux/actions/integrations/salesforce.jsx';  
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";
import _ from "lodash";
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'salesforce_v2');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    user: state.users.me,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    totalSalesforceIntegrations: _.get(state, "legacyRootReducer.settings.integrations.salesforce.totalSalesforceIntegrations", 0),
    adminConfiguration: _.get(state,"legacyRootReducer.settings.integrations.salesforce.primaryIntegration",{}),
    primaryInstanceOverride: _.get(state, "legacyRootReducer.settings.integrations.salesforce.primaryInstanceOverride"),

  }
  }

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (code) => {
      return dispatch(authenticateAccount(code));
    },
    
    fetchSalesforceIntegration: () =>{
      return dispatch(fetchSalesforceIntegration())
    },

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    } ,
    
    fetchTotalSalesforceIntegrations: () => {
      return dispatch(fetchTotalSalesforceIntegrations())
    },
    changePrimaryConfiguration: (id, code) => {
      return dispatch(changePrimaryConfiguration(id, code));
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
    }
  }
}

const SalesforcePage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SalesforceView);

export default withUseHooks(SalesforcePage);
